import { render, staticRenderFns } from "./DiagManagementDetailTutorial.vue?vue&type=template&id=b2e5a8e8&"
import script from "./DiagManagementDetailTutorial.vue?vue&type=script&lang=js&"
export * from "./DiagManagementDetailTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports